import { z } from 'zod';

export const FormSchema = z.object({
  ma_nt: z.string().min(1, 'Mã ngoại tệ là bắt buộc'),
  ten_nt: z.string().min(1, 'Tên ngoại tệ là bắt buộc'),
  ten_nt2: z.string().optional(),
  stt: z.coerce.number().optional(),
  ra_ndec: z.coerce.number().optional(),
  ra_1: z.string().optional().nullable(),
  ra_2: z.string().optional().nullable(),
  ra_3: z.string().optional().nullable(),
  ra_4: z.string().optional().nullable(),
  ra_5: z.string().optional().nullable(),
  ra_12: z.string().optional().nullable(),
  ra_22: z.string().optional().nullable(),
  ra_32: z.string().optional().nullable(),
  ra_42: z.string().optional().nullable(),
  ra_52: z.string().optional().nullable(),
  status: z.string()
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  ma_nt: '',
  ten_nt: '',
  ten_nt2: '',
  stt: 0,
  ra_ndec: 0,
  ra_1: '',
  ra_2: '',
  ra_3: '',
  ra_4: '',
  ra_5: '',
  ra_12: '',
  ra_22: '',
  ra_32: '',
  ra_42: '',
  ra_52: '',
  status: '1'
};
